import { Disclosure } from "@headlessui/react";
import { ChevronRight } from "@material-ui/icons";

const HierarchySystemInformation = ({ hierarchyData }) => {
  type DisplayRowProps = {
    label: string;
    value?: React.ReactNode;
  };

  const DisplayRow: React.FC<DisplayRowProps> = ({ label, value }) => (
    <div className="grid grid-cols-3 p-2">
      <label className="fontExpand expandedLabel mx-4">{label}</label>
      <div className="col-span-2 expandedData fontExpand">
        <label>{value}</label>
      </div>
    </div>
  );

  const display1stRow = [
    { label: "Created By:", value: hierarchyData?.createdBy },
    {
      label: "Created Date:",
      value:
        hierarchyData.createdDate &&
        new Date(hierarchyData.createdDate).toLocaleDateString() +
          " " +
          new Date(hierarchyData.createdDate).toLocaleTimeString(
            navigator.language,
            {
              hour: "2-digit",
              minute: "2-digit",
            }
          ),
    },
  ];
  const display2ndRow = [
    { label: "Modifed By:", value: hierarchyData?.modifiedBy },
    {
      label: "Modifed Date:",
      value:
        hierarchyData.modifiedDate &&
        new Date(hierarchyData.modifiedDate).toLocaleDateString() +
          " " +
          new Date(hierarchyData.modifiedDate).toLocaleTimeString(
            navigator.language,
            {
              hour: "2-digit",
              minute: "2-digit",
            }
          ),
    },
  ];

  return (
    <>
      <Disclosure defaultOpen>
        {({ open }) => (
          <>
            <div className="m-2 bg-white rounded-lg box-shadow">
              <Disclosure.Button className="disclosureBtn ml-2">
                <ChevronRight
                  className={`${
                    open ? "transform rotate-90" : " text-gray-500"
                  } text-gray-500 w-5 h-5 `}
                />
                <span className="disclosureLabel ml-2">System Information</span>
              </Disclosure.Button>
              <Disclosure.Panel className="">
                <div className="grid grid-cols-1 md:grid-cols-2 text-xs py-2">
                  <div className="p-2 divide-y">
                    {display1stRow.map((item, i) => (
                      <DisplayRow label={item.label} value={item.value} />
                    ))}
                  </div>
                  <div className="p-2 divide-y">
                    {display2ndRow.map((item, i) => (
                      <DisplayRow label={item.label} value={item.value} />
                    ))}
                  </div>
                </div>
              </Disclosure.Panel>
            </div>
          </>
        )}
      </Disclosure>
    </>
  );
};

export default HierarchySystemInformation;
